export const ru = {
    cancel: 'Отменить',
    stop: 'Остановить',
    'stop-active-brand-lift-for-campaigns': 'Исследование Brand Lift проводится в кампаниях:',
    'stop-active-brand-lift-for-campaigns-helper':
        'Не останавливайте эти кампании досрочно — собранных данных может оказаться недостаточно для достоверных выводов.'
};
